import React, {

  useEffect,

  useState,

} from "react";

import {

  useLocation,

  useNavigate,

  useParams,

} from "react-router-dom";

import {

  useDispatch,
  useSelector,

} from "react-redux";

import {

  createRazorpayOrder,

  verifyRazorpayPayment,

} from "../../actions/paymentActions";

import {

  useCart,

} from "../../components/CartContext";

import { useRestaurantSession } from "../../components/RestaurantSessionProvider";
import "./css/PaymentScreen.css";

// =====================================================

// RAZORPAY SCRIPT

// =====================================================

const RAZORPAY_SCRIPT_URL =

  "https://checkout.razorpay.com/v1/checkout.js";

function loadRazorpayScript() {

  return new Promise(

    (resolve) => {

      if (

        window.Razorpay

      ) {

        resolve(true);

        return;

      }

      const existingScript =

        document.querySelector(

          `script[src="${RAZORPAY_SCRIPT_URL}"]`

        );

      if (existingScript) {

        existingScript.addEventListener(

          "load",

          () => resolve(true)

        );

        existingScript.addEventListener(

          "error",

          () => resolve(false)

        );

        return;

      }

      const script =

        document.createElement(

          "script"

        );

      script.src =

        RAZORPAY_SCRIPT_URL;

      script.async = true;

      script.onload = () => {

        resolve(

          Boolean(

            window.Razorpay

          )

        );

      };

      script.onerror = () => {

        resolve(false);

      };

      document.body.appendChild(

        script

      );

    }

  );

}

function PaymentScreen() {

  const navigate = useNavigate();

  const location = useLocation();

  const dispatch = useDispatch();

  const {

    restaurantId,

    tableId,

  } = useParams();

  const { sessionToken } = useRestaurantSession();
  const createdOrder = useSelector((state) => state.order?.order);

  const {

    clearCart,

  } = useCart();

  // =====================================================

  // ORDER DATA

  // =====================================================

  const orderId = location.state?.orderId || createdOrder?.id || createdOrder?.order_id;
  const subtotal = location.state?.subtotal ?? createdOrder?.subtotal ?? 0;
  const tax = location.state?.tax ?? createdOrder?.tax ?? 0;
  const serviceCharge = location.state?.serviceCharge ?? createdOrder?.service_charge ?? 0;
  const total = location.state?.total ?? createdOrder?.total ?? 0;

  // =====================================================

  // STATE

  // =====================================================

  const [

    loading,

    setLoading,

  ] = useState(false);

  const [

    paymentError,

    setPaymentError,

  ] = useState("");

  // =====================================================

  // HOME PATH

  // =====================================================

  const homePath =

    `/${restaurantId}/table/${tableId}`;

  // =====================================================

  // FORMAT

  // =====================================================

  const formatPrice = (

    value

  ) => {

    return Number(

      value || 0

    ).toFixed(2);

  };

  // =====================================================

  // CHECK ORDER

  // =====================================================

  useEffect(() => {

    if (!orderId) {

      setPaymentError(

        "Order information is missing. Please create your order again."

      );

    }

  }, [

    orderId,

  ]);

  // =====================================================

  // HANDLE PAYMENT

  // =====================================================

  const handlePayment = async () => {
    if (loading) return;
    if (!sessionToken) {
      setPaymentError("Dining session unavailable. Please scan the table QR code again.");
      return;
    }

    if (!orderId) {

      setPaymentError(

        "Order information is missing."

      );

      return;

    }

    try {

      setLoading(true);

      setPaymentError("");

      // =================================================

      // LOAD RAZORPAY CHECKOUT

      // =================================================

      const razorpayLoaded =

        await loadRazorpayScript();

      if (!razorpayLoaded) {

        throw new Error(

          "Razorpay Checkout could not be loaded. Please check your internet connection and try again."

        );

      }

      // =================================================

      // CREATE RAZORPAY ORDER

      // =================================================

      const paymentOrder =

        await dispatch(

          createRazorpayOrder(

            restaurantId,

            orderId,
            sessionToken

          )

        );

      console.log(

        "RAZORPAY CREATE RESPONSE:",

        paymentOrder

      );

      if (

        !paymentOrder?.razorpay_order_id

      ) {

        throw new Error(

          "Razorpay order ID was not returned by the server."

        );

      }

      if (

        !paymentOrder?.amount

      ) {

        throw new Error(

          "Payment amount was not returned by the server."

        );

      }

      // =================================================

      // RAZORPAY OPTIONS

      // =================================================

      const options = {

        key:

          paymentOrder.key_id ||

          paymentOrder.razorpay_key_id ||

          paymentOrder.key,

        amount:

          Number(

            paymentOrder.amount

          ),

        currency:

          paymentOrder.currency ||

          "INR",

        name:

          paymentOrder.restaurant_name ||

          "Spice & Saffron",

        description:

          `Order ${paymentOrder.order_number || orderId}`,

        order_id:

          paymentOrder.razorpay_order_id,

        theme: {

          color:

            "#c94e1d",

        },

        handler:

          async function (

            response

          ) {

            try {

              setLoading(true);

              setPaymentError("");

              // =========================================

              // VERIFY PAYMENT THROUGH REDUX

              // =========================================

              const verificationData = {

                order_id:

                  orderId,

                razorpay_order_id:

                  response.razorpay_order_id,

                razorpay_payment_id:

                  response.razorpay_payment_id,

                razorpay_signature:

                  response.razorpay_signature,

              };

              const verificationResponse =

                await dispatch(

                  verifyRazorpayPayment(

                    restaurantId,

                    verificationData,
                    sessionToken

                  )

                );

              console.log(

                "RAZORPAY VERIFY RESPONSE:",

                verificationResponse

              );

              // =========================================

              // CLEAR CART ONLY AFTER SUCCESSFUL

              // VERIFICATION

              // =========================================

              clearCart();

              navigate(

                `${homePath}/success`,

                {

                  state: {

                    orderId,

                    orderNumber:

                      paymentOrder.order_number,

                    paymentMethod:

                      "ONLINE",

                    total:

                      Number(total),

                    paymentId:

                      response.razorpay_payment_id,

                  },

                }

              );

            } catch (error) {

              console.error(

                "Payment verification error:",

                error

              );

              setPaymentError(

                error?.response?.data?.detail ||

                error?.message ||

                "Payment verification failed. Please contact the restaurant."

              );

            } finally {

              setLoading(false);

            }

          },

        modal: {

          ondismiss:

            function () {

              setLoading(false);

            },

          escape:

            true,

          backdropclose:

            false,

        },

        retry: {

          enabled:

            true,

          max_count:

            3,

        },

      };

      // =================================================

      // CHECK KEY

      // =================================================

      if (!options.key) {

        throw new Error(

          "Razorpay key was not returned by the server."

        );

      }

      // =================================================

      // OPEN RAZORPAY

      // =================================================

      const razorpay =

        new window.Razorpay(

          options

        );

      razorpay.on(

        "payment.failed",

        function (

          response

        ) {

          console.error(

            "RAZORPAY PAYMENT FAILED:",

            response

          );

          setPaymentError(

            response?.error?.description ||

            "Payment was unsuccessful. Please try again."

          );

          setLoading(false);

        }

      );

      razorpay.open();

    } catch (error) {

      console.error(

        "Payment error:",

        error

      );

      setPaymentError(

        error?.response?.data?.detail ||

        error?.message ||

        "Unable to start payment."

      );

      setLoading(false);

    }

  };

  // =====================================================

  // BACK

  // =====================================================

  const handleBack = () => {
    if (loading) return;

    navigate(

      `${homePath}/order`,

      {

        state: {

          subtotal:

            Number(subtotal),

          tax:

            Number(tax),

          serviceCharge:

            Number(serviceCharge),

          total:

            Number(total),

        },

      }

    );

  };

  return (

    <main className="t7-payment-page">

      {/* =================================================

          HEADER

      \================================================= */}

      <section className="t7-payment-header">

        <div className="t7-payment-container">

          <button

            type="button"

            className="t7-payment-back"

            onClick={

              handleBack

            }

          >

            <span>

              ←

            </span>

            Back to Order

          </button>

          <div className="t7-payment-title-row">

            <div>

              <span className="t7-payment-label">

                SECURE PAYMENT

              </span>

              <h1>

                Complete Payment

              </h1>

            </div>

            <div className="t7-payment-table">

              <span>

                TABLE

              </span>

              <strong>

                {tableId}

              </strong>

            </div>

          </div>

        </div>

      </section>

      {/* =================================================

          CONTENT

      \================================================= */}

      <section className="t7-payment-content">

        <div className="t7-payment-container">

          <div className="t7-payment-layout">

            {/* =================================================

                PAYMENT CARD

            \================================================= */}

            <div className="t7-payment-main">

              <div className="t7-payment-brand-card">

                <div className="t7-payment-brand-icon">

                  ₹

                </div>

                <div>

                  <span>

                    POWERED BY

                  </span>

                  <h2>

                    Razorpay

                  </h2>

                  <p>

                    Secure online payment

                    for your order.

                  </p>

                </div>

              </div>

              <div className="t7-payment-security">

                <div>

                  🔒

                </div>

                <div>

                  <strong>

                    Secure Payment

                  </strong>

                  <p>

                    Your payment is securely

                    processed through Razorpay.

                    We never store your card

                    details.

                  </p>

                </div>

              </div>

              {paymentError && (

                <div className="t7-payment-error">

                  <strong>

                    Payment unsuccessful

                  </strong>

                  <p>

                    {paymentError}

                  </p>

                </div>

              )}

              <button

                type="button"

                className="t7-pay-now-button"

                onClick={

                  handlePayment

                }

                disabled={

                  loading ||

                  !orderId ||
                  !sessionToken

                }

              >

                {loading

                  ? "Opening Secure Payment..."

                  : `Pay ₹${formatPrice(total)}`}

                {!loading && (

                  <span>

                    →

                  </span>

                )}

              </button>

              <p className="t7-payment-bottom-note">

                🔒 Secure payment powered by

                Razorpay

              </p>

            </div>

            {/* =================================================

                SUMMARY

            \================================================= */}

            <aside className="t7-payment-summary">

              <span className="t7-payment-summary-label">

                ORDER SUMMARY

              </span>

              <h2>

                Order #{orderId}

              </h2>

              <div className="t7-payment-price-row">

                <span>

                  Subtotal

                </span>

                <strong>

                  ₹

                  {formatPrice(

                    subtotal

                  )}

                </strong>

              </div>

              <div className="t7-payment-price-row">

                <span>

                  Tax

                </span>

                <strong>

                  ₹

                  {formatPrice(

                    tax

                  )}

                </strong>

              </div>

              <div className="t7-payment-price-row">

                <span>

                  Service Charge

                </span>

                <strong>

                  ₹

                  {formatPrice(

                    serviceCharge

                  )}

                </strong>

              </div>

              <div className="t7-payment-divider"></div>

              <div className="t7-payment-total">

                <span>

                  TOTAL

                </span>

                <strong>

                  ₹

                  {formatPrice(

                    total

                  )}

                </strong>

              </div>

              <div className="t7-payment-order-info">

                <span>

                  TABLE

                </span>

                <strong>

                  {tableId}

                </strong>

              </div>

            </aside>

          </div>

        </div>

      </section>

    </main>

  );

}

export default PaymentScreen;